<template>
  <div>
    <div class="row">
      <div class="mb-3 col-md-6">
        <label for="montant_paiement" class="form-label fw-bold">Montant*</label>
        <input type="number" class="form-control" id="montant_paiement" placeholder="Montant du paiement"
          v-model="formData.montant" required>
        <small class="text-danger" v-if="errors['montant']">{{ errors['montant'][0] }}</small>

      </div>

      <div class="mb-3 col-md-6">
        <label for="methode_paiement" class="form-label">Méthode de paiement</label>
        <select class="form-select" id="methode_paiement" v-model="formData.methode" required>
          <option value="" selected disabled>-- Sélectionner la méthode de paiement --</option>
          <option value="cash" selected>Espèces</option>
          <option value="wave">wave</option>
          <option value="om">Orange Money</option>
          <option value="momo">MTN MoMo</option>
          <option value="flooz">Moov Money</option>
        </select>
        <small class="text-danger" v-if="errors['methode']">{{ errors['methode'][0] }}</small>

      </div>

      <div class="mb-3 col-md-6">
        <label for="date_paiement" class="form-label">Date de paiement</label>
        <input type="date" class="form-control" id="date_paiement" placeholder="Date du paiement"
          v-model="formData.date_paiement" required>
        <small class="text-danger" v-if="errors['date_paiement']">{{ errors['date_paiement'][0] }}</small>

      </div>

      <div class="row mt-2">
        <div class="col text-end">
          <button class="btn btn-success" @click="save"><i class="bi bi-check-circle me-1"></i>Enregistrer</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formMixin from '@/mixins/formMixin';

export default {
  name: 'PaiementForm',
  mixins: [formMixin],
  props: {
    model_id: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      defaultData: {
        methode: 'cash'
      },
      datesCols: ['date_paiement'],
      url: '/paiements'
    }
  },

  methods: {
    beforeSave() {
      this.formData.style_id = this.model_id;
    },
  },

  created() {
    // this.resetForm();
  },

}
</script>

<style scoped>
form div {
  margin-bottom: 8px
}
</style>
